import axios from "axios";

const API = axios.create({
  baseURL: "/api",
});

// attach token
API.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");
  if (token) req.headers.Authorization = `Bearer ${token}`;
  return req;
});


// =====================================
// 📊 ACTIVITY LOG SYSTEM APIs (NEW MODULE)
// =====================================

// GET REPORT (ADMIN)
export const getActivityLogsReportApi = (filters) =>
  API.get("/activity-logs/report", {
    params: filters,
  });


// EXPORT EXCEL (ADMIN)
export const exportActivityLogsExcelApi = async (filters) => {
  const res = await API.get("/activity-logs/export/excel", {
    params: filters,
    responseType: "blob", // IMPORTANT
  });

  const url = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement("a");

  link.href = url;
  link.setAttribute("download", "activity_logs.xlsx");
  document.body.appendChild(link);

  link.click();
  link.remove();
};


// GET ALL LOGS (ADMIN)
export const getAllActivityLogsApi = () =>
  API.get("/activity-logs");


// GET MY LOGS (ADMIN + STAFF)
export const getMyActivityLogsApi = () =>
  API.get("/activity-logs/my");


// GET ENTITY LOGS
export const getEntityLogsApi = (entity_type, entity_id) =>
  API.get(`/activity-logs/entity/${entity_type}/${entity_id}`);